<template>
    <input type="text" ref="datepicker" :class="inputClass" :value="value" :placeholder="placeholder" readonly @input="update($event)">
</template>

<script>
export default {
    props: {
        value: {
            default: null
        },
        placeholder: {
            default: 'Odaberite datum...'
        },
        inputClass: {
            type: String,
            default: 'form-control'
        },
        startView: {
            type: String,
            default: 'years'
        },
        startDate: {
            type: String,
            default: null
        }
    },

    mounted() {
        $(this.$refs.datepicker).datepicker({
            language: 'hr',
            format: 'dd.mm.yyyy.',
            weekStart: 1,
            startView: this.startView,
            startDate: this.startDate
        }).on('changeDate', (e) => {
            this.$emit('changedate')
            this.$emit('input', e.format())
        })
    },

    methods: {
        update(event) {
            this.$emit('input', event.target.value)
        }
    }
}
</script>
